module.exports = __webpack_public_path__ + "img/2_174.2538912a.png";